import { makeStyles } from "@mui/styles";

const aboutUsStyle = makeStyles((theme) => ({
  container: {
    padding: "4rem 2rem",
    paddingLeft: '7rem',
    paddingRight: '7rem',
    backgroundColor: theme.palette.background.gray,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '6rem',
      paddingRight: '6rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '3.5rem',
      paddingRight: '3.5rem',
      alignItems: "center",
    },
  },
  title: {
    fontWeight: "bold",
    marginBottom: "1.8rem !important",
    color: theme.palette.text.primary,
    textAlign: "left",
    [theme.breakpoints.down('sm')]: {
      textAlign: "center",
      fontSize: "2.4rem!important",
      paddingTop:"0.6rem",
      paddingBottom: "1.2rem",
    },
  },
  paragraph: {
    paddingTop:"1rem",
    fontSize: "1.2rem !important",
    color: theme.palette.text.lightGray,
    marginBottom: "6rem !important",
    textAlign: "left",
    [theme.breakpoints.down('lg')]: {
      fontSize: "1.2rem !important",
      textAlign: "justify",
      marginBottom: "4.5rem !important",
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: "justify",
      fontSize: "1.4rem !important",
      marginBottom: "3.5rem !important",
      paddingTop:"0.7rem",
    },
  },
  teamRow: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "1.4rem",
    justifyItems: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "2rem",
    },
  },

}));

export default aboutUsStyle;